  <p class="text-right">
    <span data-dismiss="modal" aria-label="Close" class="cursor-pointer mr-2">
    <span aria-hidden="true" >
      <img src="assets/themes/icons/cancel.svg" alt="close icon" (click)="goBack()"/>
      </span>
    </span>
  </p>
  <div class="messege_text text-center">
      <p class="heading-4">{{data[0]?.data?.message_title}}</p>
      <p class="secondary-paragraph">{{data[0]?.data?.message_description}}</p>
  </div>